import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "asPushPrompt" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "asPushPrompt_actions" }

import { onMounted, ref } from 'vue'
import Cookies from 'js-cookie'
import AcModal from '@ui-kit/components/AcModal.vue'
import AcButton from '@ui-kit/components/AcButton.vue'
import i18n from '@web/plugins/i18n'
import usePushSubscribe from '@web/composition/usePushSubscribe'

const ANSWER_KEY = 'acProject_push_answer'
const PROMPT_DELAY_MS = 10000


export default /*@__PURE__*/_defineComponent({
  __name: 'PushPrompt',
  setup(__props) {

const isOpen = ref(false)

const title = i18n.global.t('OneSignal.slidedown.actionTitle')
const text = i18n.global.t('OneSignal.slidedown.actionText')

const {
  isOneSignalEnable,
  subscribed,
  checkSubscribed,
  subscribe,
  unsubscribe
} = usePushSubscribe()

function hasAnswer (): boolean {
  return Boolean(Cookies.get(ANSWER_KEY) ?? localStorage.getItem(ANSWER_KEY))
}

function setAnswer (value: string): void {
  Cookies.set(ANSWER_KEY, value, { sameSite: 'Strict', expires: 7 })
  localStorage.setItem(ANSWER_KEY, value)
}

onMounted(async () => {
  if (isOneSignalEnable.value && !hasAnswer()) {
    await checkSubscribed()
    setTimeout(() => {
      isOpen.value = !subscribed.value
    }, PROMPT_DELAY_MS)
  }
})

function declinePush (): void {
  isOpen.value = false
  unsubscribe()
  setAnswer('no')
}

function enablePush (): void {
  isOpen.value = false
  subscribe()
  setAnswer('yes')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AcModal, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          class: "asPushPrompt_title",
          innerHTML: _unref(title)
        }, null, 8, _hoisted_2),
        _createElementVNode("span", {
          class: "asPushPrompt_text",
          innerHTML: _unref(text)
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(AcButton, {
            class: "asPushPrompt_btn -accept",
            type: "button",
            variant: "tonal",
            block: "",
            "aria-label": _ctx.$t('yes'),
            onClick: enablePush
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Subscribe')), 1)
            ]),
            _: 1
          }, 8, ["aria-label"]),
          _createVNode(AcButton, {
            class: "asPushPrompt_btn -decline",
            type: "button",
            variant: "tonal",
            block: "",
            "aria-label": _ctx.$t('NO'),
            onClick: declinePush
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Cancel')), 1)
            ]),
            _: 1
          }, 8, ["aria-label"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})